import {connect} from 'react-redux';
import React, {Component} from 'react';
import {fetchInvertersYear} from '../actions/notifications';
import {formatNumber} from '../util/formatters';
import {percentageColor, arrayEqual} from "../util/util";
import lodash from "lodash";
import {Select, Switch} from "antd";

class YearStatus extends Component {

    state = {
        invertersYear: [],
        showLocations: false,
        year: (new Date()).getFullYear()
    };

    componentWillMount = async () => {
        this.props.dispatch(fetchInvertersYear());

        this.setState({
            invertersYear: this.props.invertersYear
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if(!arrayEqual(nextProps.invertersYear, this.state.invertersYear))
            this.setState({
                invertersYear: nextProps.invertersYear
            });
    }

    handleYearChange = val => {
        this.setState({year: val});
        this.props.dispatch(fetchInvertersYear(val));
    }

    render = () => {
        let {invertersYear, showLocations, year} = this.state;
        let lastLocationId = 0;
        let dataList = invertersYear;
        dataList.forEach((item) => {
            item.displayName = `${item.systemId} - [${item.id}] ${item.name}`;
        });

        if(showLocations){
            dataList = [];
            invertersYear.forEach(item => {
                const locItem = dataList.find(dl => dl.id === item.id);
                if(!locItem){
                    dataList.push({...item, displayName: `[${item.id}] ${item.name}`});
                }
                else {
                    locItem.energy += parseFloat((item.energy || 0).toString());
                    locItem.expected += parseFloat((item.expected || 0).toString());
                    locItem.currentExpected += parseFloat((item.currentExpected || 0).toString());
                }
            })
        }
        return (

            <div id='right-bar'>
                <div>
                    <div className='label'><span className='name'>Jaartotalen</span></div>
                    <div>
                        Toon:
                        &nbsp;
                        <Switch value={showLocations} onChange={val => this.setState({showLocations: val})} />
                        &nbsp;
                        {showLocations ? 'locaties' : 'omvormers'}
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        Jaar:
                        &nbsp;
                        <Select value={year} onChange={this.handleYearChange}>
                            {
                                lodash.range(2018, (new Date()).getFullYear() + 1).map(year =>
                                    <Select.Option key={year} value={year} title={year.toString()}>
                                        {year}
                                    </Select.Option>
                                )
                            }
                        </Select>
                    </div>

                    {dataList.sort((item1, item2) => {
                        const compare = item1.id - item2.id;
                        if (compare === 0)
                            return item1.systemId - item2.systemId;
                        return compare;
                    }).map((item, ndx) => {
                        let addSpacing = false;
                        if (lastLocationId !== item.id) {
                            lastLocationId = item.id;
                            addSpacing = true;
                        }
                        const energy = formatNumber(item.energy);
                        const expected = formatNumber(item.expected);
                        const currentExpected = formatNumber(item.currentExpected);

                        let energyWidth = (item.energy / item.expected) * 100 / 1.2;
                        if (energyWidth > 100)
                            energyWidth = 100;
                        if (energyWidth < 0)
                            energyWidth = 0;
                        return (
                            <div key={ndx} className="bar-container" style={{
                                width: '100%',
                                height: '52px',
                                border: '1px solid #999',
                                position: 'relative',
                                marginTop: addSpacing ? '32px' : '8px',
                                backgroundColor: percentageColor((1.2*energy) / currentExpected, true, true, 0.1)
                            }}>

                                <div className="actual-value" style={{
                                    width: `${energyWidth}%`,
                                    height: '100%',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 70
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: percentageColor(((1.2*energy) / currentExpected), true, true, 0.75),
                                    }}></div>
                                </div>
                                <div className="target-value" style={{
                                    width: `${100 / 1.2}%`,
                                    height: '100%',
                                    borderRight: '2px solid #999',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 80
                                }}>
                                </div>
                                <div className="expected-value" style={{
                                    width: `${(item['current-expected'] / item.expected) * 100 / 1.2}%`,
                                    height: '100%',
                                    borderRight: '2px dashed #999',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 90
                                }}>
                                </div>
                                <span style={{
                                    lineHeight: '50px',
                                    textIndent: '120px',
                                    fontSize: '14px',
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    zIndex: 100
                                }}>{item.displayName}</span>
                                <span style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: '10px',
                                    lineHeight: '50px',
                                    fontSize: '14px',
                                    zIndex: 110
                                }}>{`${formatNumber((energy / currentExpected) * 100, 1)}%`}</span>
                                <div style={{
                                    position: 'absolute',
                                    bottom: '1px',
                                    left: '1px',
                                    padding: '0 2px',
                                    fontSize: '11px',
                                    background: 'rgba(255, 255, 255, 0.5)',
                                    zIndex: 110
                                }}>{`Nu: ${currentExpected} kWh`}</div>
                                <div style={{
                                    position: 'absolute',
                                    top: '17px',
                                    left: '1px',
                                    padding: '0 2px',
                                    fontSize: '11px',
                                    background: 'rgba(255, 255, 255, 0.5)',
                                    zIndex: 110
                                }}>{`Jaar: ${expected} kWh`}</div>
                                <div style={{
                                    position: 'absolute',
                                    top: '1px',
                                    left: '1px',
                                    padding: '0 2px',
                                    fontSize: '11px',
                                    background: 'rgba(255, 255, 255, 0.5)',
                                    zIndex: 110
                                }}>{`Opgewekt: ${energy} kWh`}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}
const mapStateToProps = ({notifications}) => {
    return {
        invertersYear: [...notifications.invertersYear]
    };
};

export default connect(mapStateToProps)(YearStatus);



// WEBPACK FOOTER //
// ./src/components/YearStatus.js